import type { Fragment, Node } from '@tiptap/pm/model';
import { NodeType } from '@tiptap/pm/model';

export const getFragmentContentNodes = (fragment?: Fragment): Node[] => {
  if (!fragment || !('content' in fragment) || !Array.isArray(fragment.content)) {
    return [];
  }

  return fragment.content.filter(isItemNode);
};

const isItemNode = (item: unknown): item is Node => {
  if (!item || typeof item !== 'object') {
    return false;
  }

  return 'type' in item && item.type instanceof NodeType;
};
